import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import InputNumber from '@/components/inputs/InputNumber/InputNumber.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox.vue';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton.vue';
import { AnswerChoices } from '@/models/VariousEnum';
import { HormonalTreatment } from '@/models/QuestQuestion';

@Component({
  components: {
    InputNumber,
    InputCheckbox,
    InputRadioButton,
  },
})
export default class HormonalTreatmentPart extends Vue {
  @Prop()
  public value!: HormonalTreatment;
  @Prop({ default: false })
  public readonly!: boolean;
  @Prop({ default: true })
  public required!: boolean;

  public answerChoices: any = AnswerChoices;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;

  private hormonalTreatmentSinceValidity: boolean = true;
  private hormonalTreatmentBeforeNotSinceValidity: boolean = true;
  private hormonalTreatmentBeforeDurationValidity: boolean = true;

  /**
   * Get an array of all the property names from the value prop in lowercase
   */
  get instanceFields(): string[] {
    if (this.value) {
      const fields: string[] = [];
      Object.keys(this.value).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }
  
  /**
   * Get the errors returned by the API corresponding to the model properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      const errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  get showMoreQuestions(): boolean {
    return this.value.flagHormonalTreatment === this.answerChoices.No;
  }

  get subQuestionRequired(): boolean {
    return this.value.flagHormonalTreatment === this.answerChoices.No;
  }

  get isHormonalTreatmentSinceValid(): boolean {
    if (this.value.flagHormonalTreatment === AnswerChoices.Yes) {
      return this.hormonalTreatmentSinceValidity;
    }
    return true;
  }

  get isHormonalTreatmentBeforeNotSinceValid(): boolean {
    if (this.value.flagHormonalTreatment === AnswerChoices.No &&
      this.value.flagHormonalTreatmentBefore === AnswerChoices.BeforeHT_NoSince) {
      return this.hormonalTreatmentBeforeNotSinceValidity;
    }
    return true;
  }

  get isHormonalTreatmentBeforeDurationValid(): boolean {
    if (this.value.flagHormonalTreatment === AnswerChoices.No &&
      this.value.flagHormonalTreatmentBefore === AnswerChoices.BeforeHT_NoSince) {
      return this.hormonalTreatmentBeforeDurationValidity;
    }
    return true;
  }

  protected mounted() {
  }

  /**
   * Set the hormonalTreatmentSinceValidity and emit event with its value to parent
   * @param validity The validity of the input
   */
  protected onHormonalTreatmentSinceValidityCheck(validity: boolean): void {
    this.hormonalTreatmentSinceValidity = validity;
    this.$emit('hormonal-treatment-since-validity', validity);
  }

  /**
   * Set the hormonalTreatmentBeforeNotSinceValidity and emit event with its value to parent
   * @param validity The validity of the input
   */
  protected onHormonalTreatmentBeforeNotSinceValidityCheck(validity: boolean): void {
    this.hormonalTreatmentBeforeNotSinceValidity = validity;
    this.$emit('hormonal-treatment-before-not-since-validity', validity);
  }

  /**
   * Set the hormonalTreatmentBeforeDurationValidity and emit event with its value to parent
   * @param validity The validity of the input
   */
   protected onHormonalTreatmentBeforeDurationValidityCheck(validity: boolean): void {
    this.hormonalTreatmentBeforeDurationValidity = validity;
    this.$emit('hormonal-treatment-before-duration-validity', validity);
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: HormonalTreatment, oldValue: HormonalTreatment) {
    if (value) {
      this.$emit('input', value);
    }
  }
}
